import React from 'react';
import { IntlShape } from 'react-intl';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Tabs as RaisinUITabs, theme } from '@raisin/components-lib';
import * as S from './styles';
import { useBuildPressPageTabs } from '../../hooks';
import { PressPageContentProps } from '../../types';

export const Tabs = ({
  pressReleases,
  mediaArticles,
  intl,
}: {
  pressReleases: PressPageContentProps['pressReleases'];
  mediaArticles: PressPageContentProps['mediaArticles'];
  intl: IntlShape;
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tabs = useBuildPressPageTabs(pressReleases, mediaArticles, intl);

  return (
    <S.TabsContainer>
      <RaisinUITabs tabs={tabs} fullWidthTabs={isMobile} />
    </S.TabsContainer>
  );
};
